import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]

  connect() {
    this.submitButtonTarget.disabled = true
    window.recaptcha = this.handleRecaptcha.bind(this)
    window.recaptchaExpired = this.handleRecaptchaExpired.bind(this)
  }

  disconnect() {
    window.recaptcha = null
    window.recaptchaExpired = null
  }

  handleRecaptcha() {
    this.submitButtonTarget.disabled = false
  }

  handleRecaptchaExpired() {
    this.submitButtonTarget.disabled = true
  }
} 